(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(87434);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59876);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22547);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42349);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85054);




var DropdownButton = function(props) {
    var item = props.item, placeHolder = props.placeHolder, isOpen = props.isOpen, width = props.width, isTable = props.isTable;
    var ref;
    var itemTitle = (ref = item === null || item === void 0 ? void 0 : item.title) !== null && ref !== void 0 ? ref : "";
    var menuButtonRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isFocused = ref1[0], setIsFocused = ref1[1];
    (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useOutsideClick */ .O3)({
        ref: menuButtonRef,
        handler: function() {
            return setIsFocused(false);
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isOpen) {
            setIsFocused(true);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .MenuButton */ .j2, {
        ref: menuButtonRef,
        width: width !== null && width !== void 0 ? width : {
            base: "400px",
            lg: "178px"
        },
        isActive: isOpen,
        isTruncated: true,
        fontSize: {
            base: "lg",
            lg: "md"
        },
        color: "gray.700",
        border: (item === null || item === void 0 ? void 0 : item.value) !== undefined ? "1px solid #319795" : "1px solid #E2E8F0",
        background: "white",
        colorScheme: "white",
        fontWeight: "normal",
        as: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx,
        iconSpacing: 5,
        textAlign: {
            base: isTable ? "center" : "left",
            md: "left"
        },
        rightIcon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_5__/* .ChevronDownIcon */ .v4, {}),
        _focus: {
            boxShadow: isFocused ? "outline" : "none"
        },
        height: {
            base: "48px",
            lg: "40px"
        },
        children: (item === null || item === void 0 ? void 0 : item.value) !== undefined ? itemTitle : placeHolder
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DropdownButton);


/***/ }),

/***/ 58810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42349);
/* harmony import */ var theme_globalStyles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86229);



var DropdownSelection = function(props) {
    var onClick = props.onClick, label = props.label, isSelected = props.isSelected, width = props.width, minWidth = props.minWidth, maxWidth = props.maxWidth, isTable = props.isTable;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .MenuItem */ .sN, {
        padding: "8px 16px",
        width: width !== null && width !== void 0 ? width : {
            base: "400px",
            lg: "178px"
        },
        minWidth: minWidth,
        maxWidth: maxWidth,
        onClick: onClick,
        className: "dropdown-selection",
        _hover: {
            background: theme_globalStyles__WEBPACK_IMPORTED_MODULE_0__/* .backGroundTeal500WithOpacity */ .az
        },
        background: isSelected ? theme_globalStyles__WEBPACK_IMPORTED_MODULE_0__/* .backGroundTeal500WithOpacity */ .az : "none",
        _focus: {
            background: isSelected ? theme_globalStyles__WEBPACK_IMPORTED_MODULE_0__/* .backGroundTeal500WithOpacity */ .az : "none"
        },
        paddingLeft: isTable ? {
            base: "45px",
            md: "16px"
        } : 4,
        height: {
            base: "48px",
            lg: "40px"
        },
        fontSize: {
            base: "lg",
            lg: "md"
        },
        children: label
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DropdownSelection);


/***/ }),

/***/ 51829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42349);
/* harmony import */ var utils_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6628);
/* harmony import */ var _DropdownButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24616);
/* harmony import */ var _DropdownSelection__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58810);





var Dropdown = function(props) {
    var options = props.options, name = props.name, setValue = props.setValue, item = props.item, width = props.width, maxWidth = props.maxWidth, text = props.text, isMatchWidth = props.isMatchWidth;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Menu */ .v2, {
        closeOnSelect: true,
        autoSelect: false,
        computePositionOnMount: true,
        matchWidth: isMatchWidth,
        children: function(param) {
            var isOpen = param.isOpen;
            /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_DropdownButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        item: item,
                        placeHolder: text,
                        isOpen: isOpen,
                        width: width
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .MenuList */ .qy, {
                        zIndex: "1001",
                        maxWidth: maxWidth,
                        minWidth: "auto",
                        children: (0,utils_common__WEBPACK_IMPORTED_MODULE_0__/* .getValidArray */ ._b)(options).map(function(option, index) {
                            /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_DropdownSelection__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                onClick: function() {
                                    return setValue(name, option);
                                },
                                label: option.title,
                                isSelected: option.value === (item === null || item === void 0 ? void 0 : item.value),
                                width: width,
                                maxWidth: maxWidth
                            }, "".concat(name, "-").concat(index));
                        })
                    })
                ]
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Dropdown);


/***/ }),

/***/ 90355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37636);




var defaultImage = "/assets/images/placeholder_image_desktop.jpg";
var Image = function(props) {
    var setDefaultImage = function setDefaultImage() {
        setImageSrc(defaultImageUrl !== null && defaultImageUrl !== void 0 ? defaultImageUrl : defaultImage);
    };
    var changeObjectFit = function changeObjectFit(naturalSize) {
        var naturalWidth = naturalSize.naturalWidth, naturalHeight = naturalSize.naturalHeight;
        if (naturalHeight > naturalWidth) {
            setObjectFit("contain");
        }
    };
    var src = props.src, alt = props.alt, _quality = props.quality, quality = _quality === void 0 ? 100 : _quality, defaultImageUrl = props.defaultImageUrl, priority = props.priority, style = props.style;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(src), imageSrc = ref[0], setImageSrc = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(quality), currentQuality = ref1[0], setCurrentQuality = ref1[1];
    var ref2;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((ref2 = props === null || props === void 0 ? void 0 : props.objectFit) !== null && ref2 !== void 0 ? ref2 : "cover"), objectFit = ref3[0], setObjectFit = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (imageSrc === defaultImage || imageSrc === defaultImageUrl) {
            setCurrentQuality(100);
        }
    }, [
        imageSrc
    ]);
    var ref4;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        alt: alt,
        placeholder: "blur",
        sizes: "100%",
        objectPosition: "50% 50%",
        blurDataURL: _constants__WEBPACK_IMPORTED_MODULE_2__/* .placeholderImage */ .j,
        src: (ref4 = imageSrc !== null && imageSrc !== void 0 ? imageSrc : defaultImageUrl) !== null && ref4 !== void 0 ? ref4 : defaultImage,
        onLoadingComplete: changeObjectFit,
        quality: currentQuality,
        layout: "fill",
        objectFit: objectFit,
        onErrorCapture: setDefaultImage,
        onError: setDefaultImage,
        priority: priority,
        style: style
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_MultiCarousel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/nuka-carousel/es-v5/carousel.js + 9 modules
var carousel = __webpack_require__(79574);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./enums/analytics/index.ts
var analytics = __webpack_require__(79251);
// EXTERNAL MODULE: ./components/Icon/index.tsx
var Icon = __webpack_require__(11665);
// EXTERNAL MODULE: ./utils/analytics.ts
var utils_analytics = __webpack_require__(26451);
;// CONCATENATED MODULE: ./components/MultiCarousel/components/ArrowControl/index.tsx








var Arrow = function(props) {
    var handleOnClick = function handleOnClick(event) {
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        isNextArrow ? nextSlide() : previousSlide();
        (0,utils_analytics/* logEvent */.Kz)(analytics/* CategoryEnum.USER */.Bf.USER, isNextArrow ? analytics/* ActionEnum.CAROUSEL_NEXT_IMAGE_CLICKED */.Xv.CAROUSEL_NEXT_IMAGE_CLICKED : analytics/* ActionEnum.CAROUSEL_PREVIOUS_IMAGE_CLICKED */.Xv.CAROUSEL_PREVIOUS_IMAGE_CLICKED);
    };
    var type = props.type, slideCount = props.slideCount, previousSlide = props.previousSlide, nextSlide = props.nextSlide, setIsHovering = props.setIsHovering;
    var isNextArrow = type === "next";
    var iconName = isNextArrow ? "circle_right_arrow.svg" : "circle_left_arrow.svg";
    var arrowProps = isNextArrow ? {
        marginRight: "1.5rem"
    } : {
        marginLeft: "1.5rem"
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onMouseEnter: function() {
            return setIsHovering(true);
        },
        hidden: slideCount <= 1,
        cursor: "pointer"
    }, arrowProps), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
            iconName: iconName,
            onClick: handleOnClick,
            width: 40,
            height: 40
        })
    }));
};
/* harmony default export */ var ArrowControl = (Arrow);

;// CONCATENATED MODULE: ./components/MultiCarousel/components/DotIndicator/index.tsx



var DotIndicator = function(props) {
    var handleOnClick = function handleOnClick(event) {
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        onClick();
    };
    var isDotSmall = props.isDotSmall, desktopDotMarginBottom = props.desktopDotMarginBottom, active = props.active, onClick = props.onClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
        "data-testid": "dot-indicator",
        width: isDotSmall ? "8px" : {
            base: "8px",
            md: "16px"
        },
        height: isDotSmall ? "8px" : {
            base: "8px",
            md: "16px"
        },
        marginLeft: isDotSmall ? "3px" : {
            base: "3px",
            md: "8px"
        },
        marginRight: isDotSmall ? "3px" : {
            base: "3px",
            md: "8px"
        },
        marginBottom: desktopDotMarginBottom ? {
            base: "14px",
            lg: props.desktopDotMarginBottom
        } : "16px",
        backgroundColor: active ? "#fff" : "background.grey.500",
        rounded: "50%",
        display: "inline-block",
        transition: "background-color 0.6s ease",
        cursor: "pointer",
        _hover: {
            backgroundColor: "#fff"
        },
        _focus: {
            backgroundColor: "#fff"
        },
        _active: {
            backgroundColor: "#fff"
        },
        onClick: handleOnClick
    });
};
/* harmony default export */ var components_DotIndicator = (DotIndicator);

;// CONCATENATED MODULE: ./components/MultiCarousel/components/DotsControl/index.tsx




var DotsControl = function(props) {
    var currentSlide = props.currentSlide, slideCount = props.slideCount, desktopDotMarginBottom = props.desktopDotMarginBottom, isDotSmall = props.isDotSmall, hidden = props.hidden, goToSlide = props.goToSlide;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
        hidden: slideCount <= 1 || hidden,
        children: Array.from(Array(slideCount).keys()).map(function(key) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_DotIndicator, {
                active: currentSlide === key,
                isDotSmall: isDotSmall,
                desktopDotMarginBottom: desktopDotMarginBottom,
                onClick: function() {
                    goToSlide(key);
                }
            }, key);
        })
    });
};
/* harmony default export */ var components_DotsControl = (DotsControl);

// EXTERNAL MODULE: ./components/MultiCarousel/multiCarousel.module.scss
var multiCarousel_module = __webpack_require__(57156);
var multiCarousel_module_default = /*#__PURE__*/__webpack_require__.n(multiCarousel_module);
;// CONCATENATED MODULE: ./components/MultiCarousel/index.tsx








var MultiCarousel = function(props) {
    var slidesToShow = props.slidesToShow, slidesToScroll = props.slidesToScroll, cellSpacing = props.cellSpacing, _wrapAround = props.wrapAround, wrapAround = _wrapAround === void 0 ? true : _wrapAround, swiping = props.swiping, dragging = props.dragging, _showArrows = props.showArrows, showArrows = _showArrows === void 0 ? true : _showArrows, _showDots = props.showDots, showDots = _showDots === void 0 ? true : _showDots, _autoPlay = props.autoPlay, autoPlay = _autoPlay === void 0 ? false : _autoPlay, speed = props.speed, desktopDotMarginBottom = props.desktopDotMarginBottom, _isDotSmall = props.isDotSmall, isDotSmall = _isDotSmall === void 0 ? true : _isDotSmall, className = props.className, _setIsHovering = props.setIsHovering, setIsHovering = _setIsHovering === void 0 ? function() {} : _setIsHovering, children = props.children, innerRef = props.innerRef;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(carousel/* Carousel */.l, {
        innerRef: innerRef,
        className: className,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToScroll,
        cellSpacing: cellSpacing,
        swiping: swiping,
        wrapAround: wrapAround,
        dragging: dragging,
        autoplay: autoPlay,
        speed: speed,
        pauseOnHover: true,
        dragThreshold: 0.3,
        renderCenterLeftControls: function(controlProps) {
            if (!showArrows) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowControl, (0,_object_spread/* default */.Z)({
                setIsHovering: setIsHovering,
                type: "prev"
            }, controlProps));
        },
        renderCenterRightControls: function(controlProps) {
            if (!showArrows) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowControl, (0,_object_spread/* default */.Z)({
                setIsHovering: setIsHovering,
                type: "next"
            }, controlProps));
        },
        renderBottomCenterControls: function(controlProps) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_DotsControl, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, controlProps), {
                desktopDotMarginBottom: desktopDotMarginBottom,
                isDotSmall: isDotSmall,
                hidden: !showDots
            }));
        },
        defaultControlsConfig: {
            containerClassName: (multiCarousel_module_default()).container
        },
        style: {
            overflowY: "unset"
        },
        children: children
    });
};
/* harmony default export */ var components_MultiCarousel = (MultiCarousel);


/***/ }),

/***/ 40756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_UTMCapture; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./utils/utm.ts
function captureUTMParameters() {
    var urlParams = new URLSearchParams(window.location.search);
    var utmSource = urlParams.get("utm_source");
    var utmMedium = urlParams.get("utm_medium");
    var utmCampaign = urlParams.get("utm_campaign");
    if (utmSource || utmMedium || utmCampaign) {
        localStorage.setItem("utm_source", utmSource || "");
        localStorage.setItem("utm_medium", utmMedium || "");
        localStorage.setItem("utm_campaign", utmCampaign || "");
    }
}

;// CONCATENATED MODULE: ./components/UTMCapture.tsx


var UTMCapture = function() {
    (0,react.useEffect)(function() {
        captureUTMParameters();
    }, []);
    return null;
};
/* harmony default export */ var components_UTMCapture = (UTMCapture);


/***/ }),

/***/ 61476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AA": function() { return /* binding */ RoomCardContainer; },
/* harmony export */   "IG": function() { return /* binding */ RoomCardBioText; },
/* harmony export */   "T9": function() { return /* binding */ RoomCardWrapper; },
/* harmony export */   "YE": function() { return /* binding */ RoomCardBioContainer; },
/* harmony export */   "_T": function() { return /* binding */ RoomCardViewHouseButton; },
/* harmony export */   "a1": function() { return /* binding */ IconWrapper; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "my": function() { return /* binding */ RoomInfoRowMobile; },
/* harmony export */   "n2": function() { return /* binding */ RoomCardViewText; },
/* harmony export */   "pI": function() { return /* binding */ RoomCardBioTitle; },
/* harmony export */   "zM": function() { return /* binding */ RoomCardBioFooter; }
/* harmony export */ });
/* unused harmony exports RoomButtonShowMap, RoomButtonShowMapText, RoomCardButtonClosePopup */
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68527);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46052);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85054);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84632);
/* harmony import */ var utils_chakraShouldForwardProp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8650);



var RoomCardWrapper = (0,utils_chakraShouldForwardProp__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, function(props) {
    return {
        position: "relative",
        marginX: "auto",
        width: {
            base: (props === null || props === void 0 ? void 0 : props.isSingleRoom) ? "full" : "calc(100vw - 100px)",
            md: "full"
        },
        justifyContent: "center",
        paddingX: {
            base: "2px",
            md: 0
        }
    };
});
var RoomCardContainer = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
    baseStyle: function() {
        return {
            width: "100%",
            height: "100%",
            marginX: "auto",
            background: "#FFFFFF",
            boxShadow: {
                base: "base",
                lg: "unset"
            },
            border: {
                base: "unset",
                lg: "1px solid #E2E8F0"
            },
            borderRadius: "8px",
            rounded: "lg",
            overflow: "hidden",
            "&:hover": {
                boxShadow: "md"
            },
            cursor: "pointer"
        };
    }
});
var RoomCardBioContainer = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
    baseStyle: function() {
        return {
            paddingY: 4,
            paddingX: 6
        };
    }
});
var RoomCardBioTitle = (0,utils_chakraShouldForwardProp__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, function(props) {
    return {
        color: (props === null || props === void 0 ? void 0 : props.blackColor) ? "text.primary" : "text.secondary",
        fontWeight: 600,
        fontSize: "1rem",
        marginBottom: "8px !important",
        marginTop: "4px !important",
        transition: "all 250ms",
        cursor: "pointer",
        "&:hover": {
            transition: "all 250ms",
            color: "text.secondary"
        }
    };
});
var RoomCardBioFooter = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
    baseStyle: function() {
        return {
            flexDirection: "column",
            flex: 1,
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer"
        };
    }
});
var RoomCardBioText = (0,utils_chakraShouldForwardProp__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, function(props) {
    return {
        color: (props === null || props === void 0 ? void 0 : props.price) ? "text.secondary" : "text.grey.600",
        fontWeight: (props === null || props === void 0 ? void 0 : props.bold) ? 600 : (props === null || props === void 0 ? void 0 : props.normal) === "true" ? "normal" : 500,
        fontSize: "14px",
        whiteSpace: "wrap",
        marginLeft: (props === null || props === void 0 ? void 0 : props.bold) || (props === null || props === void 0 ? void 0 : props.hasMarginLeft) ? "6px !important" : 0,
        marginY: "0 !important"
    };
});
var RoomButtonShowMap = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
    baseStyle: function() {
        return {
            position: "absolute",
            background: "background.button",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "base",
            top: {
                base: "65%",
                lg: "-30px"
            }
        };
    }
});
var RoomButtonShowMapText = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
    baseStyle: function() {
        return {
            fontWeight: 600,
            fontSize: "lg",
            color: "#fff",
            marginLeft: 2.5
        };
    }
});
var Flex = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,utils_chakraShouldForwardProp__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, function(props) {
    return {
        width: "100%",
        alignItems: "flex-start",
        flexDirection: "column",
        justifyContent: "space-between",
        marginTop: (props === null || props === void 0 ? void 0 : props.price) ? "8px" : 0
    };
}), {
    target: "e197580i0"
})("img{min-width:16px !important;}> div:first-of-type > div:first-of-type{min-width:16px !important;align-self:flex-start;padding-top:8px;}");
var IconWrapper = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
    baseStyle: function() {
        return {
            marginX: 0.5,
            justifyContent: "center"
        };
    }
});
var RoomCardViewHouseButton = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
    baseStyle: function() {
        return {
            background: "white",
            border: "1px solid #E2E8F0",
            borderRadius: "6px",
            display: "flex",
            width: "calc(100% - 48px)",
            justifyContent: "center",
            alignItems: "center",
            marginX: 6,
            marginBottom: 5,
            height: {
                base: "48px",
                lg: "40px"
            }
        };
    }
});
var RoomCardViewText = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
    baseStyle: function() {
        return {
            fontSize: {
                base: "lg",
                lg: "md"
            },
            lineHeight: {
                base: 7,
                lg: 6
            },
            color: "#2D3748",
            fontWeight: 600,
            marginRight: "8px !important"
        };
    }
});
var RoomCardButtonClosePopup = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
    baseStyle: function() {
        return {
            background: "background.white.500",
            borderRadius: "6px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            right: "1rem",
            top: "1rem",
            zIndex: 1000000,
            width: 10,
            height: 10,
            padding: 0
        };
    }
});
var RoomInfoRowMobile = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
    target: "e197580i1"
})("span{width:20px !important;}");


/***/ }),

/***/ 26704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$M": function() { return /* binding */ getAllBuildiumUnitIds; },
/* harmony export */   "UI": function() { return /* binding */ getListingMedia; },
/* harmony export */   "_m": function() { return /* binding */ getButtonProps; },
/* harmony export */   "om": function() { return /* binding */ getMedia; },
/* harmony export */   "t1": function() { return /* binding */ getImageMediaUnit; },
/* harmony export */   "uy": function() { return /* binding */ getAmenitiesDataWithIcon; }
/* harmony export */ });
/* unused harmony export leadingNumberRegex */
/* harmony import */ var enums_media__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50898);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6628);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63516);




function getButtonProps(isActive, isFullWidth) {
    return isActive ? {
        colorScheme: "teal",
        borderColor: "teal",
        isFullWidth: isFullWidth !== null && isFullWidth !== void 0 ? isFullWidth : undefined
    } : {
        isFullWidth: isFullWidth !== null && isFullWidth !== void 0 ? isFullWidth : undefined
    };
}
function getMedia(media) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : enums_media__WEBPACK_IMPORTED_MODULE_0__/* .MediaType.IMAGE */ .D.IMAGE;
    var ref, ref1, ref2;
    var _url;
    return (ref2 = (ref1 = (ref = (0,utils_common__WEBPACK_IMPORTED_MODULE_2__/* .getValidArray */ ._b)(media)) === null || ref === void 0 ? void 0 : ref.filter(function(mediaDetail) {
        return mediaDetail.type === type;
    })) === null || ref1 === void 0 ? void 0 : ref1.sort(function(a, b) {
        return a.order - b.order;
    })) === null || ref2 === void 0 ? void 0 : ref2.map(function(mediaDetail) {
        return {
            name: mediaDetail.name,
            url: (_url = mediaDetail.url) !== null && _url !== void 0 ? _url : mediaDetail === null || mediaDetail === void 0 ? void 0 : mediaDetail.buildiumUrl
        };
    });
}
function getListingMedia(media) {
    return (0,utils_common__WEBPACK_IMPORTED_MODULE_2__/* .getValidArray */ ._b)(media).map(function(mediaDetail) {
        return {
            name: mediaDetail === null || mediaDetail === void 0 ? void 0 : mediaDetail.name,
            url: mediaDetail === null || mediaDetail === void 0 ? void 0 : mediaDetail.url
        };
    });
}
function getAmenitiesDataWithIcon(amenities, enabledKeys) {
    var amenitiesData = [];
    for(var key in amenities){
        if (enabledKeys.includes(key)) {
            var defaultLabel = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(_constants__WEBPACK_IMPORTED_MODULE_3__/* .defaultAmenities */ .sO, key);
            var label = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(amenities, key, defaultLabel);
            var iconName = _constants__WEBPACK_IMPORTED_MODULE_3__/* .AMENITIES_ICON_MAP */ .i7[key];
            if (label) {
                amenitiesData.push({
                    label: label,
                    iconName: iconName
                });
            }
        }
    }
    return amenitiesData;
}
function getAllBuildiumUnitIds(houseDetail) {
    var ref;
    return (0,utils_common__WEBPACK_IMPORTED_MODULE_2__/* .getValidArray */ ._b)(houseDetail === null || houseDetail === void 0 ? void 0 : houseDetail.units).map(function(unit) {
        return (ref = unit === null || unit === void 0 ? void 0 : unit.buildiumUnitId) !== null && ref !== void 0 ? ref : 0;
    });
}
function getImageMediaUnit(media) {
    var ref, ref1, ref2;
    var ref3, ref4, _url;
    return (ref2 = (ref1 = (ref = (0,utils_common__WEBPACK_IMPORTED_MODULE_2__/* .getValidArray */ ._b)(media)) === null || ref === void 0 ? void 0 : ref.filter(function(mediaDetail) {
        return mediaDetail.type === enums_media__WEBPACK_IMPORTED_MODULE_0__/* .MediaType.IMAGE */ .D.IMAGE;
    })) === null || ref1 === void 0 ? void 0 : ref1.sort(function(mediaItemA, mediaItemB) {
        return ((ref3 = mediaItemA === null || mediaItemA === void 0 ? void 0 : mediaItemA.unitOrder) !== null && ref3 !== void 0 ? ref3 : 0) - ((ref4 = mediaItemB === null || mediaItemB === void 0 ? void 0 : mediaItemB.unitOrder) !== null && ref4 !== void 0 ? ref4 : 0);
    })) === null || ref2 === void 0 ? void 0 : ref2.map(function(mediaDetail) {
        return {
            name: mediaDetail.name,
            url: (_url = mediaDetail.url) !== null && _url !== void 0 ? _url : mediaDetail === null || mediaDetail === void 0 ? void 0 : mediaDetail.buildiumUrl
        };
    });
}
var leadingNumberRegex = /[0-9]+.\s+/;


/***/ }),

/***/ 24439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_RoomCard; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/advancedFormat.js
var advancedFormat = __webpack_require__(28734);
var advancedFormat_default = /*#__PURE__*/__webpack_require__.n(advancedFormat);
// EXTERNAL MODULE: ./enums/roomDefaultValue/index.ts
var roomDefaultValue = __webpack_require__(97530);
// EXTERNAL MODULE: ./enums/theme/index.ts
var theme = __webpack_require__(60431);
// EXTERNAL MODULE: ./hooks/useBreakPoint.ts
var useBreakPoint = __webpack_require__(41894);
;// CONCATENATED MODULE: ./hooks/useScrollingEvent.ts

function useScrollingEvent() {
    var onScroll = function onScroll() {
        setIsScrolling(true);
        if (timer !== null) {
            clearTimeout(timer);
        }
        timer = setTimeout(function() {
            setIsScrolling(false);
        }, 1000);
    };
    var ref = (0,react.useState)(false), isScrolling = ref[0], setIsScrolling = ref[1];
    var timer = null;
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", onScroll);
        return function() {
            return window.removeEventListener("scroll", onScroll);
        };
    }, []);
    return isScrolling;
}

// EXTERNAL MODULE: ./hooks/useStores.ts
var useStores = __webpack_require__(19263);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/identity.js
var identity = __webpack_require__(6557);
var identity_default = /*#__PURE__*/__webpack_require__.n(identity);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/pickBy.js
var pickBy = __webpack_require__(35937);
var pickBy_default = /*#__PURE__*/__webpack_require__.n(pickBy);
// EXTERNAL MODULE: ./node_modules/lodash/set.js
var set = __webpack_require__(36968);
var set_default = /*#__PURE__*/__webpack_require__.n(set);
// EXTERNAL MODULE: ./node_modules/mobx-react/dist/mobxreact.esm.js
var mobxreact_esm = __webpack_require__(29323);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/Icon/index.tsx
var Icon = __webpack_require__(11665);
// EXTERNAL MODULE: ./components/Image/index.tsx
var Image = __webpack_require__(90355);
// EXTERNAL MODULE: ./components/MultiCarousel/index.tsx + 3 modules
var MultiCarousel = __webpack_require__(409);
// EXTERNAL MODULE: ./components/MultiCarousel/constants.ts
var constants = __webpack_require__(17991);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/RoomCard/roomCard.styles.ts
var roomCard_styles = __webpack_require__(61476);
// EXTERNAL MODULE: ./routes/index.ts + 2 modules
var routes = __webpack_require__(1179);
// EXTERNAL MODULE: ./utils/common.ts
var common = __webpack_require__(6628);
// EXTERNAL MODULE: ./components/pages/ListingPage/components/RoomCard/roomCard.styles.ts
var RoomCard_roomCard_styles = __webpack_require__(12033);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/isSameOrBefore.js
var isSameOrBefore = __webpack_require__(37412);
var isSameOrBefore_default = /*#__PURE__*/__webpack_require__.n(isSameOrBefore);
;// CONCATENATED MODULE: ./components/pages/ListingPage/components/RoomCard/utils.ts


dayjs_min_default().extend((isSameOrBefore_default()));
function getCarouselTransformValue(transformValue) {
    if (!(transformValue === null || transformValue === void 0 ? void 0 : transformValue.includes("calc"))) {
        return transformValue;
    }
    var originalTransformValue = transformValue === null || transformValue === void 0 ? void 0 : transformValue.substring(transformValue.indexOf("-"), transformValue.indexOf("%") + 1);
    return "translate3d(".concat(originalTransformValue, ", 0px, 0px)");
}

// EXTERNAL MODULE: ./components/pages/ListingPage/components/RoomCard/roomCard.module.scss
var roomCard_module = __webpack_require__(63559);
var roomCard_module_default = /*#__PURE__*/__webpack_require__.n(roomCard_module);
;// CONCATENATED MODULE: ./components/pages/ListingPage/components/RoomCard/index.tsx



























dayjs_min_default().extend((advancedFormat_default()));
var RoomCard = function(props) {
    var handleSetPosition = function handleSetPosition() {
        window && window.open(handleOpenHouseDetail(), "_blank");
        if (!popup) {
            listingStore.setSelectedHouseId(id);
            changePosition(lat, lng, 16);
        }
    };
    var handleOpenHouseDetail = function handleOpenHouseDetail() {
        var bathRoomType = query.bathRoomType, price = query.price;
        var newQuery = new URLSearchParams(pickBy_default()({
            bathRoomType: String(bathRoomType !== null && bathRoomType !== void 0 ? bathRoomType : ""),
            price: String(price !== null && price !== void 0 ? price : "")
        }, (identity_default()))).toString();
        var houseUrl = "".concat(routes/* default.detail.value */.Z.detail.value(Number(buildiumPropertyId))).concat(newQuery ? "?" + newQuery : "");
        return houseUrl;
    };
    var ref;
    var id = props.id, lat = props.lat, lng = props.lng, _address = props.address, address = _address === void 0 ? "" : _address, _unitCount = props.unitCount, unitCount = _unitCount === void 0 ? 0 : _unitCount, buildiumPropertyId = props.buildiumPropertyId, availableDate = props.availableDate, lowestUnitPrice = props.lowestUnitPrice, images = props.images, popup = props.popup, defaultImageUrl = props.defaultImageUrl, changePosition = props.changePosition, closePopupOnClick = props.closePopupOnClick, placeType = props.placeType, _numberOfBedrooms = props.numberOfBedrooms, numberOfBedrooms = _numberOfBedrooms === void 0 ? 0 : _numberOfBedrooms, _numberOfBathrooms = props.numberOfBathrooms, numberOfBathrooms = _numberOfBathrooms === void 0 ? 0 : _numberOfBathrooms, tags = props.tags;
    var router = (0,next_router.useRouter)();
    var query = router.query;
    var listingStore = (0,useStores/* useStores */.m)().listingStore;
    var selectedHouseId = listingStore.selectedHouseId;
    var shortAddress = (0,common/* getCensorAddress */.Yc)(String(address), buildiumPropertyId);
    var isDesktop = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.LG */.yE.LG);
    var ref1 = (0,react.useState)(false), isHovering = ref1[0], setIsHovering = ref1[1];
    var validImages = !isEmpty_default()(images) ? (0,common/* getValidArray */._b)(images) : (0,common/* getDefaultSlide */.bC)(constants/* defaultSlide */.p, defaultImageUrl !== null && defaultImageUrl !== void 0 ? defaultImageUrl : (ref = constants/* defaultSlide.0 */.p[0]) === null || ref === void 0 ? void 0 : ref.url);
    var isEntireHouse = placeType === roomDefaultValue/* EPlaceTypeEnum.ENTIRE_HOUSE */.C.ENTIRE_HOUSE;
    var bathrooms = numberOfBathrooms === 0 ? 1 : numberOfBathrooms;
    var bedrooms = numberOfBedrooms === 0 ? 1 : numberOfBedrooms;
    var isScrolling = useScrollingEvent();
    var carouselRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (!isDesktop && isScrolling) {
            var carouselStyle = get_default()(carouselRef, "current.children[0].style");
            var transformValue = getCarouselTransformValue(carouselStyle === null || carouselStyle === void 0 ? void 0 : carouselStyle.transform);
            set_default()(carouselStyle, "transform", transformValue);
        }
    }, [
        isScrolling
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomCard_roomCard_styles/* RoomCardWrapper */.T9, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RoomCard_roomCard_styles/* RoomCardContainer */.AA, {
            onClick: handleSetPosition,
            popup: popup,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomCard_roomCard_styles/* RoomCardButtonClosePopup */.Ml, {
                    hidden: !popup,
                    onClick: closePopupOnClick,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                        iconName: "x.svg",
                        width: 13,
                        height: 13
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MultiCarousel/* default */.Z, {
                    className: (roomCard_module_default()).sliderContainer,
                    dragging: !isDesktop && !isScrolling,
                    setIsHovering: setIsHovering,
                    swiping: !isDesktop && !isScrolling,
                    showDots: false,
                    showArrows: isDesktop && isHovering,
                    innerRef: carouselRef,
                    children: validImages.map(function(image, index) {
                        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* AspectRatio */.oM, {
                            onMouseOver: function() {
                                return setIsHovering(true);
                            },
                            onMouseOut: function() {
                                return setIsHovering(false);
                            },
                            ratio: 16 / 10,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                                src: image === null || image === void 0 ? void 0 : image.url,
                                alt: image === null || image === void 0 ? void 0 : image.name,
                                quality: 20,
                                defaultImageUrl: defaultImageUrl
                            })
                        }, "roomcard-item".concat(index));
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* HStack */.Ug, {
                    spacing: 1,
                    position: "absolute",
                    top: "5px",
                    right: "6px",
                    children: tags === null || tags === void 0 ? void 0 : tags.map(function(tag) {
                        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                            background: "".concat(tag === null || tag === void 0 ? void 0 : tag.color, ".500"),
                            paddingX: 2,
                            height: "16px",
                            alignItems: "center",
                            textAlign: "center",
                            fontSize: "8px",
                            fontWeight: "500",
                            boxShadow: "base",
                            color: "white",
                            zIndex: "1",
                            borderRadius: "10px",
                            display: "flex",
                            children: tag === null || tag === void 0 ? void 0 : tag.title
                        }, tag === null || tag === void 0 ? void 0 : tag.id);
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RoomCard_roomCard_styles/* RoomCardBioContainer */.YE, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Link */.rU, {
                            _focus: {
                                boxShadow: "none"
                            },
                            isExternal: true,
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomCard_roomCard_styles/* RoomCardBioTitle */.pI, {
                                noMargin: true,
                                blackColor: popup || selectedHouseId !== id,
                                children: shortAddress
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RoomCard_roomCard_styles/* RoomCardBioFooter */.zM, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RoomCard_roomCard_styles/* Flex */.kC, {
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Flex */.kC, {
                                            children: isEntireHouse ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomCard_roomCard_styles/* RoomCardBioText */.IG, {
                                                        children: (0,common/* getValidEnding */.PV)(bedrooms, "Bedroom")
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(roomCard_styles/* IconWrapper */.a1, {
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                            iconName: "dot.svg",
                                                            width: 4,
                                                            height: 4
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomCard_roomCard_styles/* RoomCardBioText */.IG, {
                                                        children: (0,common/* getValidEnding */.PV)(bathrooms, "Bath")
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomCard_roomCard_styles/* RoomCardBioText */.IG, {
                                                children: (unitCount >= 2 ? 2 : 1) + "+ beds available"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomCard_roomCard_styles/* RoomCardBioText */.IG, {
                                            children: "From"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RoomCard_roomCard_styles/* Flex */.kC, {
                                    price: true,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                    iconName: "circle_check.svg",
                                                    width: 16,
                                                    height: 16
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RoomCard_roomCard_styles/* RoomCardBioText */.IG, {
                                                    bold: true,
                                                    children: [
                                                        "Avail. ",
                                                        (0,common/* formatAvailableDate */.K3)(availableDate)
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RoomCard_roomCard_styles/* RoomCardBioText */.IG, {
                                            price: true,
                                            normal: true,
                                            children: [
                                                "$",
                                                lowestUnitPrice,
                                                "+/mo"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* HStack */.Ug, {
                    spacing: 0,
                    width: "full",
                    paddingInline: 6,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Link */.rU, {
                        isExternal: true,
                        rel: "noopener noreferrer",
                        width: "full",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RoomCard_roomCard_styles/* RoomCardViewHouseButton */._T, {
                            hidden: !popup,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomCard_roomCard_styles/* RoomCardViewText */.n2, {
                                    children: "View house"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                    iconName: "chevron_right.svg",
                                    size: isDesktop ? 16 : 18
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_RoomCard = ((0,mobxreact_esm/* observer */.Pi)(RoomCard));


/***/ }),

/***/ 12033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AA": function() { return /* binding */ RoomCardContainer; },
/* harmony export */   "IG": function() { return /* binding */ RoomCardBioText; },
/* harmony export */   "Ml": function() { return /* binding */ RoomCardButtonClosePopup; },
/* harmony export */   "T9": function() { return /* binding */ RoomCardWrapper; },
/* harmony export */   "YE": function() { return /* binding */ RoomCardBioContainer; },
/* harmony export */   "_T": function() { return /* binding */ RoomCardViewHouseButton; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "n2": function() { return /* binding */ RoomCardViewText; },
/* harmony export */   "pI": function() { return /* binding */ RoomCardBioTitle; },
/* harmony export */   "zM": function() { return /* binding */ RoomCardBioFooter; }
/* harmony export */ });
/* unused harmony export IconWrapper */
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46052);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68527);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85054);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84632);
/* harmony import */ var enums_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60431);
/* harmony import */ var utils_chakraShouldForwardProp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8650);




var RoomCardWrapper = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
    baseStyle: function() {
        return {
            position: "relative",
            marginX: "auto",
            width: "100%",
            justifyContent: "center"
        };
    }
});
var RoomCardContainer = (0,utils_chakraShouldForwardProp__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, function(props) {
    return {
        width: "100%",
        height: "100%",
        marginX: "auto",
        background: "#FFFFFF",
        boxShadow: "base",
        "&:hover": {
            boxShadow: "md"
        },
        rounded: "lg",
        overflow: "hidden",
        cursor: (props === null || props === void 0 ? void 0 : props.popup) ? "unset" : "pointer"
    };
});
var RoomCardBioContainer = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
    baseStyle: function() {
        return {
            padding: "20px 24px"
        };
    }
});
var RoomCardBioTitle = (0,utils_chakraShouldForwardProp__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, function(props) {
    return {
        color: (props === null || props === void 0 ? void 0 : props.blackColor) ? "text.primary" : "text.secondary",
        fontWeight: 600,
        fontSize: "1rem",
        marginTop: "0 !important",
        marginBottom: "8px !important",
        transition: "all 250ms",
        "&:hover": {
            transition: "all 250ms",
            color: "text.secondary"
        }
    };
});
var RoomCardBioFooter = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
    baseStyle: function() {
        return {
            flexDirection: "column",
            flex: 1,
            justifyContent: "space-between",
            alignItems: "center"
        };
    }
});
var RoomCardBioText = (0,utils_chakraShouldForwardProp__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, function(props) {
    return {
        color: (props === null || props === void 0 ? void 0 : props.price) ? "text.secondary" : "text.grey.600",
        fontWeight: (props === null || props === void 0 ? void 0 : props.bold) ? 600 : (props === null || props === void 0 ? void 0 : props.price) ? 700 : (props === null || props === void 0 ? void 0 : props.normal) === "true" ? "normal" : 400,
        fontSize: (props === null || props === void 0 ? void 0 : props.price) ? "1rem" : "14px",
        marginLeft: (props === null || props === void 0 ? void 0 : props.bold) ? "4px !important" : 0,
        lineHeight: (props === null || props === void 0 ? void 0 : props.price) ? "1.5rem" : "20px",
        marginY: "0 !important"
    };
});
var Flex = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,utils_chakraShouldForwardProp__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, function(props) {
    return {
        width: "100%",
        alignItems: "center",
        justifyContent: "space-between",
        marginTop: (props === null || props === void 0 ? void 0 : props.price) ? "8px" : 0
    };
}), {
    target: "e1awmcft0"
})("> div:first-of-type > div:first-of-type{min-width:16px !important;align-self:flex-start;padding-top:8px;}");
var IconWrapper = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
    baseStyle: function() {
        return {
            marginX: "8px"
        };
    }
});
var RoomCardViewHouseButton = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
    baseStyle: function() {
        return {
            width: "100%",
            background: "background.button",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: {
                base: 12,
                md: 10
            },
            lineHeight: {
                base: 7,
                md: 6
            },
            marginBottom: 5,
            _hover: {
                background: "background.buttonHover"
            }
        };
    }
});
var RoomCardViewText = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
    baseStyle: function() {
        return {
            fontSize: {
                base: "lg",
                md: "md"
            },
            color: "white",
            fontWeight: 600,
            marginRight: "8px !important"
        };
    }
});
var RoomCardButtonClosePopup = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
    baseStyle: function() {
        return {
            background: "background.white.500",
            borderRadius: "6px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            right: "1rem",
            top: "1rem",
            zIndex: enums_theme__WEBPACK_IMPORTED_MODULE_1__/* .EZIndexLayer.CONTENT_VIEW */ .qd.CONTENT_VIEW,
            width: "40px",
            height: "40px",
            padding: 0
        };
    }
});


/***/ }),

/***/ 32881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZI": function() { return /* binding */ placeType; },
/* harmony export */   "dD": function() { return /* binding */ leaseLengths; },
/* harmony export */   "dZ": function() { return /* binding */ bathroomType; },
/* harmony export */   "q7": function() { return /* binding */ roomFilterPrice; }
/* harmony export */ });
/* unused harmony exports metroList, metroListWithAllCity */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var enums_roomDefaultValue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97530);
/* harmony import */ var routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1179);



var roomFilterPrice = [
    {
        title: "Less than $400",
        value: "0-400"
    },
    {
        title: "$400 - $500",
        value: "400-500"
    },
    {
        title: "$500 - $600",
        value: "500-600"
    },
    {
        title: "$600 - $700",
        value: "600-700"
    },
    {
        title: "More than $700",
        value: "700-"
    }
];
var leaseLengths = [
    {
        title: "3 months",
        value: 3
    },
    {
        title: "6 months",
        value: 6
    },
    {
        title: "12 months",
        value: 12
    },
    {
        title: "18 months",
        value: 18
    }
];
var bathroomType = [
    {
        title: "Private bathroom",
        value: enums_roomDefaultValue__WEBPACK_IMPORTED_MODULE_0__/* .EBathRoomTypeEnum.PRIVATE_BATHROOM */ .B.PRIVATE_BATHROOM
    },
    {
        title: "Shared bathroom",
        value: enums_roomDefaultValue__WEBPACK_IMPORTED_MODULE_0__/* .EBathRoomTypeEnum.SHARED_BATHROOM */ .B.SHARED_BATHROOM
    }
];
var placeType = [
    {
        title: "Private room",
        value: enums_roomDefaultValue__WEBPACK_IMPORTED_MODULE_0__/* .EPlaceTypeEnum.PRIVATE_ROOM */ .C.PRIVATE_ROOM
    },
    {
        title: "Entire house",
        value: enums_roomDefaultValue__WEBPACK_IMPORTED_MODULE_0__/* .EPlaceTypeEnum.ENTIRE_HOUSE */ .C.ENTIRE_HOUSE
    }
];
var metroList = [
    {
        label: "Kansas City",
        value: "".concat(routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].home.value */ .Z.home.value, "?metro=Kansas+City"),
        zoomLevel: 10,
        imageUrl: "/assets/images/metro/kansas_city.png"
    },
    {
        label: "Dallas-Fort Worth",
        value: "".concat(routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].home.value */ .Z.home.value, "?metro=Dallas-Fort+Worth"),
        zoomLevel: 9,
        imageUrl: "/assets/images/metro/dallas_fort_worth.png"
    },
    {
        label: "San Antonio",
        value: "".concat(routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].home.value */ .Z.home.value, "?metro=San+Antonio"),
        zoomLevel: 11,
        imageUrl: "/assets/images/metro/san_antonio.png"
    },
    {
        label: "Austin",
        value: "".concat(routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].home.value */ .Z.home.value, "?metro=Austin"),
        zoomLevel: 12,
        imageUrl: "/assets/images/metro/austin.png"
    },
    {
        label: "Pittsburgh",
        value: "".concat(routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].home.value */ .Z.home.value, "?metro=Pittsburgh"),
        zoomLevel: 12,
        imageUrl: "/assets/images/metro/pittsburgh.png"
    },
    {
        label: "Indianapolis",
        value: "".concat(routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].home.value */ .Z.home.value, "?metro=Indianapolis"),
        zoomLevel: 11,
        imageUrl: "/assets/images/metro/indianapolis.png"
    },
    {
        label: "Phoenix",
        value: "".concat(routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].home.value */ .Z.home.value, "?metro=Phoenix"),
        zoomLevel: 11,
        imageUrl: "/assets/images/metro/phoenix.png"
    },
    {
        label: "Tampa",
        value: "".concat(routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].home.value */ .Z.home.value, "?metro=Tampa"),
        zoomLevel: 11,
        imageUrl: "/assets/images/metro/tampa.png"
    },
    {
        label: "Houston",
        value: "".concat(routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].home.value */ .Z.home.value, "?metro=Houston"),
        zoomLevel: 11,
        imageUrl: "/assets/images/metro/houston.png"
    },
    {
        label: "Atlanta",
        value: "".concat(routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].home.value */ .Z.home.value, "?metro=Atlanta"),
        zoomLevel: 11,
        imageUrl: "/assets/images/metro/atlanta.png"
    }
];
var metroListWithAllCity = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(metroList).concat([
    {
        label: "All Cities",
        value: "".concat(routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].home.value */ .Z.home.value),
        zoomLevel: 11,
        imageUrl: "/assets/images/metro/all_city.png"
    }
]);


/***/ }),

/***/ 25624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TA": function() { return /* binding */ getCoordinatesFromHouses; },
/* harmony export */   "Tb": function() { return /* binding */ getValidValue; },
/* harmony export */   "vl": function() { return /* binding */ getQueryParams; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_isUndefined__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52353);
/* harmony import */ var lodash_isUndefined__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isUndefined__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6628);



function getCoordinatesFromHouses(houses) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var coordinates = houses.filter(function(house) {
        return (0,utils_common__WEBPACK_IMPORTED_MODULE_2__/* .checkValidCoordinates */ .fG)((ref1 = (ref = house === null || house === void 0 ? void 0 : house.fakeLat) !== null && ref !== void 0 ? ref : house === null || house === void 0 ? void 0 : house.lat) !== null && ref1 !== void 0 ? ref1 : 0, (ref3 = (ref2 = house === null || house === void 0 ? void 0 : house.fakeLng) !== null && ref2 !== void 0 ? ref2 : house === null || house === void 0 ? void 0 : house.lng) !== null && ref3 !== void 0 ? ref3 : 0);
    }).map(function(house) {
        return [
            (ref5 = (ref4 = house === null || house === void 0 ? void 0 : house.fakeLat) !== null && ref4 !== void 0 ? ref4 : house === null || house === void 0 ? void 0 : house.lat) !== null && ref5 !== void 0 ? ref5 : 0,
            (ref7 = (ref6 = house === null || house === void 0 ? void 0 : house.fakeLng) !== null && ref6 !== void 0 ? ref6 : house === null || house === void 0 ? void 0 : house.lng) !== null && ref7 !== void 0 ? ref7 : 0
        ];
    }) || [
        0,
        0
    ];
    return coordinates;
}
function getValidValue(newValue, currentValue) {
    if (newValue === undefined || newValue === "undefined") {
        return "";
    }
    var isDifferent = String(newValue) !== String(currentValue);
    var validOldValue = currentValue === undefined || currentValue === "undefined" ? "" : currentValue;
    var result = isDifferent ? newValue : validOldValue;
    return result;
}
function getQueryParams(data, query) {
    var currentPrice = query.price, currentBathRoomType = query.bathRoomType, currentMoveDate = query.moveDate, currentMetro = query.metro, currentPlaceType = query.placeType;
    var moveDate = data.moveDate, metro = data.metro, price = data.price, bathRoomType = data.bathRoomType, placeType = data.placeType;
    var queryParams = {
        moveDate: !lodash_isUndefined__WEBPACK_IMPORTED_MODULE_1___default()(moveDate) ? dayjs__WEBPACK_IMPORTED_MODULE_0___default()(moveDate).format("MM-DD-YYYY") !== String(currentMoveDate) ? dayjs__WEBPACK_IMPORTED_MODULE_0___default()(moveDate).format("MM-DD-YYYY") : currentMoveDate : undefined,
        metro: getValidValue(String(metro), String(currentMetro)),
        price: getValidValue(String(price === null || price === void 0 ? void 0 : price.value), String(currentPrice)),
        bathRoomType: getValidValue(String(bathRoomType === null || bathRoomType === void 0 ? void 0 : bathRoomType.value), String(currentBathRoomType)),
        placeType: getValidValue(String(placeType === null || placeType === void 0 ? void 0 : placeType.value), String(currentPlaceType))
    };
    return queryParams;
}


/***/ }),

/***/ 24510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C8": function() { return /* binding */ MOBILE_HOUSE_DEFAULT_IMAGE; },
/* harmony export */   "O3": function() { return /* binding */ MOBILE_ROOM_DEFAULT_IMAGE; },
/* harmony export */   "Xm": function() { return /* binding */ DESKTOP_ROOM_DEFAULT_IMAGE; },
/* harmony export */   "yN": function() { return /* binding */ DESKTOP_HOUSE_DEFAULT_IMAGE; }
/* harmony export */ });
var MOBILE_HOUSE_DEFAULT_IMAGE = "/assets/images/placeholder_image_mobile.jpg";
var DESKTOP_HOUSE_DEFAULT_IMAGE = "/assets/images/placeholder_image_desktop.jpg";
var MOBILE_ROOM_DEFAULT_IMAGE = "/assets/images/placeholder_image_mobile.jpg";
var DESKTOP_ROOM_DEFAULT_IMAGE = "/assets/images/placeholder_image_desktop.jpg";


/***/ }),

/***/ 50898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ MediaType; },
/* harmony export */   "h": function() { return /* binding */ MediaMode; }
/* harmony export */ });
var MediaType;
(function(MediaType) {
    MediaType["IMAGE"] = "Image";
    MediaType["VIDEO"] = "Video";
    MediaType["FLOOR_PLAN"] = "FloorPlan";
    MediaType["VR"] = "VR";
})(MediaType || (MediaType = {}));
var MediaMode;
(function(MediaMode) {
    MediaMode["PHOTO"] = "Photo";
    MediaMode["MAP"] = "Map";
    MediaMode["VR"] = "VR";
})(MediaMode || (MediaMode = {}));


/***/ }),

/***/ 97530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ EBathRoomTypeEnum; },
/* harmony export */   "C": function() { return /* binding */ EPlaceTypeEnum; }
/* harmony export */ });
var EBathRoomTypeEnum;
(function(EBathRoomTypeEnum) {
    EBathRoomTypeEnum["PRIVATE_BATHROOM"] = "private";
    EBathRoomTypeEnum["SHARED_BATHROOM"] = "shared";
})(EBathRoomTypeEnum || (EBathRoomTypeEnum = {}));
var EPlaceTypeEnum;
(function(EPlaceTypeEnum) {
    EPlaceTypeEnum["PRIVATE_ROOM"] = "private-room";
    EPlaceTypeEnum["ENTIRE_HOUSE"] = "entire-house";
})(EPlaceTypeEnum || (EPlaceTypeEnum = {}));


/***/ }),

/***/ 87434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./enums/featureFlags/index.ts
var featureFlags = __webpack_require__(9322);
// EXTERNAL MODULE: ./enums/roomDefaultValue/index.ts
var roomDefaultValue = __webpack_require__(97530);
// EXTERNAL MODULE: ./node_modules/react-unleash-flags/lib/index.js
var lib = __webpack_require__(68401);
// EXTERNAL MODULE: ./components/Layout/MainLayout/index.tsx + 39 modules
var MainLayout = __webpack_require__(23983);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./enums/constants/images.ts
var constants_images = __webpack_require__(24510);
// EXTERNAL MODULE: ./enums/theme/index.ts
var theme = __webpack_require__(60431);
// EXTERNAL MODULE: ./hooks/useBreakPoint.ts
var useBreakPoint = __webpack_require__(41894);
// EXTERNAL MODULE: ./hooks/useStores.ts
var useStores = __webpack_require__(19263);
// EXTERNAL MODULE: ./node_modules/lodash/identity.js
var identity = __webpack_require__(6557);
var identity_default = /*#__PURE__*/__webpack_require__.n(identity);
// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__(57557);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ./node_modules/lodash/pickBy.js
var pickBy = __webpack_require__(35937);
var pickBy_default = /*#__PURE__*/__webpack_require__.n(pickBy);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var index_esm = __webpack_require__(47516);
// EXTERNAL MODULE: ./API/error.ts
var API_error = __webpack_require__(76214);
// EXTERNAL MODULE: ./components/Icon/index.tsx
var Icon = __webpack_require__(11665);
// EXTERNAL MODULE: ./components/UTMCapture.tsx + 1 modules
var UTMCapture = __webpack_require__(40756);
// EXTERNAL MODULE: ./utils/common.ts
var common = __webpack_require__(6628);
// EXTERNAL MODULE: ./components/pages/DetailPage/utils.tsx
var utils = __webpack_require__(26704);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(60155);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js
var chakra_ui_system_esm = __webpack_require__(46052);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js + 1 modules
var chakra_ui_button_esm = __webpack_require__(85054);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(84632);
;// CONCATENATED MODULE: ./components/pages/ListingPage/components/FilterResultBar/filterResultBar.styles.ts



var ResultWrapper = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Flex */.kC, {
    baseStyle: function() {
        return {
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            paddingX: {
                base: 4,
                md: 8
            },
            paddingTop: {
                base: 3,
                md: 4,
                lg: 6
            },
            paddingBottom: {
                base: 3,
                md: 4,
                lg: 0
            },
            marginBottom: "1px",
            background: "white",
            position: {
                base: "sticky",
                lg: "unset"
            },
            top: {
                base: "64px",
                lg: "unset"
            },
            zIndex: {
                base: theme/* EZIndexLayer.FILTER_BAR */.qd.FILTER_BAR,
                lg: "unset"
            },
            boxShadow: {
                base: "base",
                lg: "none"
            },
            "&:hover": {
                boxShadow: {
                    base: "md",
                    lg: "none"
                }
            }
        };
    }
});
var TextFilterResult = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Text */.xv, {
    baseStyle: function() {
        return {
            fontSize: "md",
            fontWeight: 600,
            color: "gray.500"
        };
    }
}), {
    target: "eoq378o0"
})("b{color:var(--chakra-colors-gray-700);}");
var FilterButtonModal = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_button_esm/* Button */.zx, {
    baseStyle: function() {
        return {
            display: {
                lg: "none"
            },
            border: "solid 1px",
            backgroundColor: "transparent",
            borderRadius: "6px",
            padding: "10px",
            justifyContent: "center",
            alignItems: "center"
        };
    }
});

;// CONCATENATED MODULE: ./components/pages/ListingPage/components/FilterResultBar/index.tsx










var FilterResultBar = function(props) {
    var countHouseList = props.countHouseList, onClick = props.onClick;
    var router = (0,next_router.useRouter)();
    var query = router.query;
    var currentMetro = query.metro;
    var isMobile = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.BASE */.yE.BASE, theme/* EBreakPoint.MD */.yE.MD);
    var numberFiltered = Object.keys(pickBy_default()(omit_default()(query, "limit"), (identity_default()))).length;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ResultWrapper, {
        order: {
            base: -1,
            lg: 0
        },
        children: [
            countHouseList > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TextFilterResult, {
                children: [
                    isMobile ? "" : "Browse",
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
                        children: countHouseList
                    }),
                    " ",
                    isMobile ? "" : "move-in ready",
                    " home",
                    countHouseList > 1 ? "s " : " ",
                    currentMetro ? "in " : "",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
                        children: currentMetro ? currentMetro + (isMobile ? "" : ".") : ""
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextFilterResult, {
                children: "No rooms available this time"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FilterButtonModal, {
                colorScheme: "white",
                onClick: onClick,
                borderColor: numberFiltered > 0 ? "teal.500" : "gray.200",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(io5_index_esm/* IoFilter */.FpS, {
                    color: numberFiltered > 0 ? "#319795" : "#2D3748",
                    size: 20
                })
            })
        ]
    });
};
/* harmony default export */ var components_FilterResultBar = (FilterResultBar);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/chakra-ui-image.esm.js + 1 modules
var chakra_ui_image_esm = __webpack_require__(78428);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./theme/globalStyles.ts
var globalStyles = __webpack_require__(86229);
;// CONCATENATED MODULE: ./components/pages/ListingPage/components/LowerMidScroll/SavedMoneyBlock/constant.ts
var savedMoneyBlockText = {
    firstLine: "HomeRoom ",
    secondLine: "members save ",
    thirdLine: "an average of ",
    boldText: "50% on rent"
};
var savedMoneyBlockQuestion = "What will you do with all that spare cash?";

;// CONCATENATED MODULE: ./components/pages/ListingPage/components/LowerMidScroll/SavedMoneyBlock/savedMoneyBlock.style.ts

var SavedMoneyBlockContainer = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Box */.xu, {
    baseStyle: function() {
        return {
            height: {
                base: "fit-content",
                md: "full"
            },
            minHeight: {
                base: 40,
                md: "330px",
                lg: 80
            },
            width: "100%",
            marginX: "auto",
            background: "#F3EADA",
            boxShadow: "md",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "&:hover": {
                boxShadow: "md"
            },
            rounded: "lg",
            overflow: "hidden"
        };
    }
});

;// CONCATENATED MODULE: ./components/pages/ListingPage/components/LowerMidScroll/SavedMoneyBlock/index.tsx








var SavedMoneyBlock = function() {
    var firstLine = savedMoneyBlockText.firstLine, secondLine = savedMoneyBlockText.secondLine, thirdLine = savedMoneyBlockText.thirdLine, boldText = savedMoneyBlockText.boldText;
    var isMobile = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.BASE */.yE.BASE, theme/* EBreakPoint.MD */.yE.MD);
    var isTablet = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.MD */.yE.MD);
    var isSmallDesktopMin = (0,react_responsive.useMediaQuery)({
        minWidth: globalStyles/* maxTabletWidth */.dy
    });
    var isSmallDesktopMax = (0,react_responsive.useMediaQuery)({
        maxWidth: 1400
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SavedMoneyBlockContainer, {
        children: [
            isTablet && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                width: 64,
                marginY: {
                    md: "69px",
                    lg: "auto"
                },
                marginX: {
                    md: 10,
                    lg: 8
                },
                spacing: 6,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                        marginBottom: isSmallDesktopMin && isSmallDesktopMax ? 6 : 0,
                        spacing: 4,
                        justifyContent: "center",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_image_esm/* Image */.Ee, {
                                width: "112px",
                                height: "122px",
                                src: "/assets/images/saved_money_block.png",
                                alt: "savedMoneyBlock"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                                width: "128px",
                                height: "122px",
                                fontSize: "lg",
                                fontWeight: "500",
                                color: "teal.700",
                                lineHeight: 7,
                                children: [
                                    firstLine,
                                    secondLine,
                                    thirdLine,
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
                                        children: boldText
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                            fontSize: "lg",
                            fontWeight: "500",
                            color: "gray.700",
                            lineHeight: 7,
                            children: savedMoneyBlockQuestion
                        })
                    })
                ]
            }),
            isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
                height: "fit-content",
                margin: 6,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                    height: "max",
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_image_esm/* Image */.Ee, {
                            width: "72px",
                            height: "72px",
                            src: "/assets/images/saved_money_block.png",
                            alt: "savedMoneyBlock"
                        }),
                        "\\",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                            spacing: 4,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                                    fontSize: "md",
                                    fontWeight: "500",
                                    color: "teal.700",
                                    lineHeight: 6,
                                    children: [
                                        firstLine,
                                        secondLine,
                                        thirdLine,
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
                                            children: boldText
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                    fontSize: "md",
                                    fontWeight: "500",
                                    color: "gray.700",
                                    lineHeight: 6,
                                    children: savedMoneyBlockQuestion
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var LowerMidScroll_SavedMoneyBlock = (SavedMoneyBlock);

;// CONCATENATED MODULE: ./components/pages/ListingPage/components/LowerMidScroll/TrustCredibilityBlock/constants.ts
var trustCredibilityBlockText = [
    "Seriously afforable rent",
    "Fine-tuned roommate matching",
    "Access to a nationwide network of homes",
    "Fast Wi-fi, furnished common areas",
    "Easy transfer within our network",
    "24/7 member support"
];

// EXTERNAL MODULE: ./utils/chakraShouldForwardProp.ts
var chakraShouldForwardProp = __webpack_require__(8650);
;// CONCATENATED MODULE: ./components/pages/ListingPage/components/LowerMidScroll/TrustCredibilityBlock/trustCredibilityBlock.style.ts


var TrustCredibilityBlockContainer = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* GridItem */.P4, {
    baseStyle: function() {
        return {
            width: "100%",
            height: "100%",
            marginX: "auto",
            position: "relative",
            display: "flex",
            flexDirection: "column",
            background: "linear-gradient(281.35deg, #319795 0.99%, #38736B 94.71%)",
            boxShadow: "base",
            rounded: "lg",
            overflow: "hidden",
            "&:hover": {
                boxShadow: "md"
            }
        };
    }
});
var Favicon = (0,chakraShouldForwardProp/* default */.Z)(chakra_ui_image_esm/* Image */.Ee, function(props) {
    return {
        position: "absolute",
        right: (props === null || props === void 0 ? void 0 : props.isMobile) ? "-32px" : "0px",
        top: (props === null || props === void 0 ? void 0 : props.isMobile) ? "68px" : "-36px",
        opacity: 0.05
    };
});
var CardText = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Text */.xv, {
    baseStyle: function() {
        return {
            color: "white",
            fontWeight: "normal",
            margin: "0px !important"
        };
    }
});

;// CONCATENATED MODULE: ./components/pages/ListingPage/components/LowerMidScroll/TrustCredibilityBlock/index.tsx







var TrustCredibilityBlock = function() {
    var isMobile = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.BASE */.yE.BASE, theme/* EBreakPoint.MD */.yE.MD);
    var isTablet = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.MD */.yE.MD);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrustCredibilityBlockContainer, {
        colSpan: {
            base: 1,
            md: 2
        },
        paddingY: {
            base: 6,
            md: 8
        },
        paddingLeft: {
            base: 6,
            md: 8
        },
        paddingRight: {
            base: 2,
            md: 8
        },
        height: "fit-content",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Favicon, {
                src: "/assets/images/favicon_white.png",
                alt: "favicon",
                isMobile: isMobile
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                alignItems: "flex-start",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                        iconName: "white_logo.svg",
                        width: isMobile ? 162 : 242,
                        height: isMobile ? 24 : 36,
                        className: "homeroom-logo"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                        fontSize: {
                            base: "md",
                            md: "lg"
                        },
                        color: "gray.50",
                        fontWeight: "medium",
                        lineHeight: {
                            base: 6,
                            md: 7
                        },
                        children: "Roommate-living you\u2019ll actually love."
                    })
                ]
            }),
            isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
                alignItems: "flex-start",
                marginTop: 4,
                gap: 3,
                children: trustCredibilityBlockText.map(function(line, index) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                        gap: 2,
                        width: "full",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                flexShrink: 0,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                    iconName: "tick.svg",
                                    size: 16
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardText, {
                                fontSize: "sm",
                                lineHeight: 5,
                                children: line
                            })
                        ]
                    }, "mobile-".concat(index));
                })
            }),
            isTablet && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Grid */.rj, {
                marginTop: 6,
                columnGap: 6,
                rowGap: 2,
                gridTemplateColumns: "repeat(2, 1fr)",
                children: trustCredibilityBlockText.map(function(line, index) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                        gap: 2,
                        alignItems: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                marginTop: 1,
                                flexShrink: 0,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                    iconName: "tick.svg",
                                    size: 16
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardText, {
                                fontSize: "md",
                                lineHeight: 6,
                                children: line
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var LowerMidScroll_TrustCredibilityBlock = (TrustCredibilityBlock);

// EXTERNAL MODULE: ./components/pages/ListingPage/components/RoomCard/index.tsx + 2 modules
var RoomCard = __webpack_require__(24439);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/skeleton/dist/chakra-ui-skeleton.esm.js + 1 modules
var chakra_ui_skeleton_esm = __webpack_require__(67989);
// EXTERNAL MODULE: ./components/pages/ListingPage/components/RoomCard/roomCard.styles.ts
var roomCard_styles = __webpack_require__(12033);
;// CONCATENATED MODULE: ./components/pages/ListingPage/components/RoomCardSkeleton/index.tsx




var RoomCardSkeleton = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(roomCard_styles/* RoomCardWrapper */.T9, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(roomCard_styles/* RoomCardContainer */.AA, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* AspectRatio */.oM, {
                    ratio: 16 / 10,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_skeleton_esm/* Skeleton */.Od, {
                        size: "full"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(roomCard_styles/* RoomCardBioContainer */.YE, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_skeleton_esm/* SkeletonText */.N2, {
                        noOfLines: 3,
                        spacing: "4"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_RoomCardSkeleton = (RoomCardSkeleton);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chakra-ui-modal.esm.js + 52 modules
var chakra_ui_modal_esm = __webpack_require__(28018);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/customParseFormat.js
var customParseFormat = __webpack_require__(10285);
var customParseFormat_default = /*#__PURE__*/__webpack_require__.n(customParseFormat);
// EXTERNAL MODULE: ./node_modules/mobx-react/dist/mobxreact.esm.js
var mobxreact_esm = __webpack_require__(29323);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/menu/dist/chakra-ui-menu.esm.js + 3 modules
var chakra_ui_menu_esm = __webpack_require__(42349);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./components/Dropdown/index.tsx
var Dropdown = __webpack_require__(51829);
// EXTERNAL MODULE: ./components/Dropdown/DropdownButton/index.tsx
var DropdownButton = __webpack_require__(24616);
// EXTERNAL MODULE: ./components/Dropdown/DropdownSelection/index.tsx
var DropdownSelection = __webpack_require__(58810);
// EXTERNAL MODULE: ./components/pages/ListingPage/components/RoomFilter/constants.ts
var constants = __webpack_require__(32881);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/select/dist/chakra-ui-select.esm.js
var chakra_ui_select_esm = __webpack_require__(11391);
;// CONCATENATED MODULE: ./components/pages/ListingPage/components/RoomFilter/roomFilter.styles.ts



var Container = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Box */.xu, {
    baseStyle: function() {
        return {
            background: "white",
            position: "sticky",
            zIndex: theme/* EZIndexLayer.FILTER_BAR */.qd.FILTER_BAR,
            top: "64px"
        };
    }
});
var RoomFilterWrapper = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Box */.xu, {
    baseStyle: function() {
        return {
            display: {
                base: "none",
                lg: "block"
            },
            boxShadow: "base"
        };
    }
});
var RoomFilterContainer = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Box */.xu, {
    baseStyle: function() {
        return {
            width: "100%",
            display: "flex",
            alignItems: "center",
            paddingY: 4,
            paddingX: {
                base: 0,
                lg: 8
            },
            flexWrap: {
                base: "wrap",
                lg: "nowrap"
            },
            gap: {
                base: 6,
                lg: 4
            }
        };
    }
});
var Text = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Text */.xv, {
    baseStyle: function() {
        return {
            fontSize: "lg",
            lineHeight: 7,
            color: "gray.500",
            fontWeight: 600,
            marginInlineEnd: {
                base: "0.75rem !important",
                md: "1.5rem !important"
            }
        };
    }
});
var ModalHeader = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_modal_esm/* ModalHeader */.xB, {
    baseStyle: function() {
        return {
            boxShadow: "base",
            marginBottom: "1px"
        };
    }
});
var ButtonModal = (0,chakraShouldForwardProp/* default */.Z)(chakra_ui_button_esm/* Button */.zx, function(props) {
    return {
        width: "50%",
        background: (props === null || props === void 0 ? void 0 : props.resetButton) ? "transparent" : "teal.500",
        border: (props === null || props === void 0 ? void 0 : props.resetButton) && "none",
        color: (props === null || props === void 0 ? void 0 : props.resetButton) ? "teal" : "#fff",
        transition: "all 0.2s ease-in-out",
        height: {
            base: "48px",
            lg: "40px"
        },
        fontSize: {
            base: "lg",
            lg: "md"
        },
        _hover: {
            background: !(props === null || props === void 0 ? void 0 : props.resetButton) && "teal.600",
            transition: "all 0.2s ease-in-out"
        },
        _active: {
            background: !(props === null || props === void 0 ? void 0 : props.resetButton) && "teal.700",
            transition: "all 0.2s ease-in-out"
        }
    };
});
var ModalContent = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_modal_esm/* ModalContent */.hz, {
    baseStyle: function() {
        return {
            marginTop: 0
        };
    }
});
var ModalFooter = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_modal_esm/* ModalFooter */.mz, {
    baseStyle: function() {
        return {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
        };
    }
});
var SelectWrapper = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Box */.xu, {
    baseStyle: function() {
        return {
            width: {
                base: "min(calc(100vw - 48px), 400px)",
                md: "400px",
                lg: "178px"
            },
            height: "40px"
        };
    }
});
var Select = (0,chakraShouldForwardProp/* default */.Z)(chakra_ui_select_esm/* Select */.Ph, function(props) {
    return {
        color: "#000",
        borderRadius: "6px",
        border: "1px solid",
        borderColor: (props === null || props === void 0 ? void 0 : props.active) ? "teal.500" : "gray.200",
        _hover: {
            borderColor: (props === null || props === void 0 ? void 0 : props.active) ? "teal.500" : "gray.300"
        },
        _focus: {
            borderColor: (props === null || props === void 0 ? void 0 : props.active) ? "teal.500" : "gray.300"
        }
    };
});
var ButtonApplyFilter = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_button_esm/* Button */.zx, {
    baseStyle: function() {
        return {
            background: "teal.500",
            color: "#fff",
            transition: "all 0.2s ease-in-out"
        };
    }
});

// EXTERNAL MODULE: ./node_modules/dayjs/plugin/advancedFormat.js
var advancedFormat = __webpack_require__(28734);
var advancedFormat_default = /*#__PURE__*/__webpack_require__.n(advancedFormat);
;// CONCATENATED MODULE: ./components/pages/ListingPage/components/RoomFilter/components/RoomFilterDatePicker/roomFilterDatePicker.styles.ts

var DatePickerWrapper = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Flex */.kC, {
    baseStyle: function() {
        return {
            border: "solid 1px",
            borderColor: "background.grey.200",
            whiteSpace: "nowrap",
            paddingLeft: {
                base: 4,
                lg: 4
            },
            paddingRight: {
                base: 3,
                lg: 3
            },
            paddingY: "7px",
            borderRadius: "6px",
            justifyContent: "space-between",
            width: {
                base: "min(calc(100vw - 48px), 400px)",
                md: "400px",
                lg: "178px"
            },
            height: {
                base: "48px",
                lg: "40px"
            },
            alignItems: "center"
        };
    }
});
var DatePickerText = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Text */.xv, {
    baseStyle: function() {
        return {
            color: "text.grey.800",
            fontSize: {
                base: "lg",
                lg: "md"
            }
        };
    }
});

;// CONCATENATED MODULE: ./components/pages/ListingPage/components/RoomFilter/components/RoomFilterDatePicker/index.tsx







dayjs_min_default().extend((advancedFormat_default()));
var RoomFilterDatePicker = function(props, ref) {
    var value = props.value, onClick = props.onClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DatePickerWrapper, {
        onClick: onClick,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatePickerText, {
                children: value && dayjs_min_default()(value).isValid() ? dayjs_min_default()(value).format("ddd, MMM Do") : "Move-in date"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                width: 5,
                height: 5,
                alignSelf: "center",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                    iconName: "date.svg",
                    width: 20,
                    height: 20,
                    onClick: onClick
                })
            })
        ]
    });
};
/* harmony default export */ var components_RoomFilterDatePicker = (RoomFilterDatePicker);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
;// CONCATENATED MODULE: ./components/pages/ListingPage/components/RoomFilter/components/RoomFilterForm/utils.ts



function sortMetroByOrder(metroList) {
    return (0,common/* getValidArray */._b)((0,_to_consumable_array/* default */.Z)(metroList)).sort(function(currentMetro, nextMetro) {
        return get_default()(currentMetro, "order", 0) - get_default()(nextMetro, "order", 0);
    });
}

;// CONCATENATED MODULE: ./components/pages/ListingPage/components/RoomFilter/components/RoomFilterForm/index.tsx













var RoomFilterForm = function(props) {
    var metroList = props.metroList;
    var ref = (0,dist_index_esm/* useFormContext */.Gc)(), setValue = ref.setValue, control = ref.control;
    var startDate = (0,dist_index_esm/* useWatch */.qo)({
        control: control,
        name: "moveDate"
    });
    var metroValue = (0,dist_index_esm/* useWatch */.qo)({
        control: control,
        name: "metro"
    });
    var price = (0,dist_index_esm/* useWatch */.qo)({
        control: control,
        name: "price"
    });
    var bathroomTypeValue = (0,dist_index_esm/* useWatch */.qo)({
        control: control,
        name: "bathRoomType"
    });
    var placeTypeValue = (0,dist_index_esm/* useWatch */.qo)({
        control: control,
        name: "placeType"
    }) || constants/* placeType.0 */.ZI[0];
    //* INFO: Temporarily comment LeaseLengths to reuse later
    // const leaseLengthTime: IRoomFilterItem = useWatch({ control, name: 'leaseLength' })
    var DatePickerDropdown = function() {
        return (0,react.useMemo)(function() {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectWrapper, {
                border: startDate ? "1px solid #319795" : "none",
                borderRadius: startDate ? "6px" : "none",
                className: "date-wrapper",
                height: {
                    base: "48px",
                    lg: "40px"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_index_esm/* Controller */.Qr, {
                    name: "moveDate",
                    control: control,
                    render: function(param) {
                        var _field = param.field, onChange = _field.onChange, value = _field.value;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((react_datepicker_min_default()), {
                            selected: value,
                            onChange: function(date) {
                                return onChange(date);
                            },
                            customInput: /*#__PURE__*/ (0,react.createElement)(/*#__PURE__*/ (0,react.forwardRef)(components_RoomFilterDatePicker))
                        });
                    }
                })
            });
        }, [
            startDate
        ]);
    };
    var ref1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_menu_esm/* Menu */.v2, {
                closeOnSelect: true,
                autoSelect: false,
                computePositionOnMount: true,
                children: function(param) {
                    var isOpen = param.isOpen;
                    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropdownButton/* default */.Z, {
                                item: {
                                    title: metroValue,
                                    value: metroValue
                                },
                                placeHolder: "Select Metro",
                                isOpen: isOpen
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_menu_esm/* MenuList */.qy, {
                                maxHeight: "calc(100vh - 140px)",
                                overflowY: "auto",
                                zIndex: theme/* EZIndexLayer.CONTENT_VIEW */.qd.CONTENT_VIEW,
                                minWidth: "auto",
                                children: sortMetroByOrder(metroList).map(function(metro, index) {
                                    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropdownSelection/* default */.Z, {
                                        onClick: function() {
                                            return setValue("metro", metro.name, {
                                                shouldDirty: true
                                            });
                                        },
                                        label: (ref1 = metro === null || metro === void 0 ? void 0 : metro.name) !== null && ref1 !== void 0 ? ref1 : "",
                                        isSelected: metro.name === metroValue,
                                        width: {
                                            base: "min(calc(100vw - 48px), 400px)",
                                            md: "400px",
                                            lg: "178px"
                                        }
                                    }, "metro-".concat(index));
                                })
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* default */.Z, {
                name: "price",
                text: "Price",
                item: price,
                options: constants/* roomFilterPrice */.q7,
                setValue: function(name, value) {
                    return setValue(name, value, {
                        shouldDirty: true
                    });
                },
                width: {
                    base: "min(calc(100vw - 48px), 400px)",
                    md: "400px",
                    lg: "178px"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatePickerDropdown, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* default */.Z, {
                name: "bathRoomType",
                text: "Bathroom type",
                item: bathroomTypeValue,
                options: constants/* bathroomType */.dZ,
                setValue: function(name, value) {
                    return setValue(name, value, {
                        shouldDirty: true
                    });
                },
                width: {
                    base: "min(calc(100vw - 48px), 400px)",
                    md: "400px",
                    lg: "178px"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* default */.Z, {
                name: "placeType",
                text: "Type of place",
                item: placeTypeValue,
                options: constants/* placeType */.ZI,
                setValue: function(name, value) {
                    return setValue(name, value, {
                        shouldDirty: true
                    });
                },
                width: {
                    base: "min(calc(100vw - 48px), 400px)",
                    md: "400px",
                    lg: "178px"
                }
            })
        ]
    });
};
/* harmony default export */ var components_RoomFilterForm = (RoomFilterForm);

;// CONCATENATED MODULE: ./components/pages/ListingPage/components/RoomFilter/index.tsx

















dayjs_min_default().extend((customParseFormat_default()));
var defaultValues = {
    placeType: {
        label: constants/* placeType.0.title */.ZI[0].title,
        value: String(constants/* placeType.0.value */.ZI[0].value)
    }
};
var RoomFilter = function(props) {
    var onSubmit = function onSubmit(data) {
        setOpenModalFilter(false);
        setQueryParams(data);
    };
    var resetForm = function resetForm() {
        setIsLoadingReset(true);
        reset(defaultValues);
        setQueryParams(defaultValues);
    };
    var closeModal = function closeModal() {
        setOpenModalFilter(false);
    };
    var ref, ref1;
    var openModalFilter = props.openModalFilter, setOpenModalFilter = props.setOpenModalFilter, setQueryParams = props.setQueryParams, buttonRef = props.buttonRef, metroList = props.metroList;
    var methods = (0,dist_index_esm/* useForm */.cI)({
        defaultValues: defaultValues
    });
    var handleSubmit = methods.handleSubmit, reset = methods.reset, _formState = methods.formState, isSubmitting = _formState.isSubmitting, isDirty = _formState.isDirty;
    var spinnerStore = (0,useStores/* useStores */.m)().spinnerStore;
    var isLoading = spinnerStore.isLoading;
    var isDesktop = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.LG */.yE.LG);
    var router = (0,next_router.useRouter)();
    var query = router.query;
    var ref2 = (0,react.useState)(false), isLoadingReset = ref2[0], setIsLoadingReset = ref2[1];
    (0,react.useEffect)(function() {
        var currentPriceFilter = (0,common/* getValidArray */._b)(constants/* roomFilterPrice */.q7).find(function(roomFilter) {
            return (roomFilter === null || roomFilter === void 0 ? void 0 : roomFilter.value) === (query === null || query === void 0 ? void 0 : query.price);
        });
        var currentBathRoomTypeFilter = (0,common/* getValidArray */._b)(constants/* bathroomType */.dZ).find(function(roomFilter) {
            return (roomFilter === null || roomFilter === void 0 ? void 0 : roomFilter.value) === (query === null || query === void 0 ? void 0 : query.bathRoomType);
        });
        //* INFO: Temporarily comment LeaseLengths to reuse later
        // const currentLeaseLengthsFilter: IRoomFilterItem | undefined = getValidArray(leaseLengths).find(
        //   (roomFilter) => roomFilter?.value?.toString() === query?.leaseLength
        // )
        var currentMoveDateFilter = (query === null || query === void 0 ? void 0 : query.moveDate) ? dayjs_min_default()("".concat(query === null || query === void 0 ? void 0 : query.moveDate), "MM/DD/YYYY").toDate() : undefined;
        var currentPlaceTypeFilter = (0,common/* getValidArray */._b)(constants/* placeType */.ZI).find(function(roomFilter) {
            return (roomFilter === null || roomFilter === void 0 ? void 0 : roomFilter.value) === (query === null || query === void 0 ? void 0 : query.placeType);
        }) || constants/* placeType.0 */.ZI[0];
        reset({
            metro: query === null || query === void 0 ? void 0 : query.metro,
            price: currentPriceFilter,
            moveDate: currentMoveDateFilter,
            bathRoomType: currentBathRoomTypeFilter,
            placeType: currentPlaceTypeFilter
        });
        if (isLoadingReset) {
            setIsLoadingReset(false);
        }
    }, [
        query
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods), {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_system_esm/* chakra.form */.m$.form, {
                onSubmit: handleSubmit(onSubmit),
                id: "filter-form",
                children: isDesktop ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomFilterWrapper, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RoomFilterContainer, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_RoomFilterForm, {
                                metroList: metroList
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonApplyFilter, {
                                colorScheme: "teal",
                                type: "submit",
                                form: "filter-form",
                                isLoading: isSubmitting || isLoading,
                                children: "Apply filter"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* Button */.zx, {
                                variant: "outline",
                                type: "reset",
                                isLoading: isSubmitting || isLoadingReset,
                                onClick: resetForm,
                                hidden: !isDirty && ((ref = Object.keys(query)) === null || ref === void 0 ? void 0 : ref.length) === 0,
                                children: "Reset"
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_modal_esm/* Drawer */.dy, {
                    isOpen: openModalFilter && !isDesktop,
                    size: "sm",
                    placement: "right",
                    onClose: closeModal,
                    finalFocusRef: buttonRef,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* DrawerOverlay */.P1, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* DrawerContent */.sc, {
                            zIndex: theme/* EZIndexLayer.MODAL */.qd.MODAL,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                                flexDirection: "column",
                                height: "stretch",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_modal_esm/* ModalHeader */.xB, {
                                        boxShadow: "base",
                                        zIndex: theme/* EZIndexLayer.NAV */.qd.NAV,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        height: "60px",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
                                                children: "Filter"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* ModalCloseButton */.ol, {
                                                color: "#000",
                                                onClick: closeModal,
                                                zIndex: theme/* EZIndexLayer.NAV */.qd.NAV,
                                                position: "static"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* ModalBody */.fe, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomFilterContainer, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_RoomFilterForm, {
                                                metroList: metroList
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_modal_esm/* ModalFooter */.mz, {
                                        placeItems: "flex-end",
                                        marginBottom: 4,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonModal, {
                                                hidden: !isDirty && ((ref1 = Object.keys(query)) === null || ref1 === void 0 ? void 0 : ref1.length) === 0,
                                                resetButton: true,
                                                marginRight: 4,
                                                isLoading: isSubmitting || isLoadingReset,
                                                onClick: resetForm,
                                                children: "Reset"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonModal, {
                                                flex: 1,
                                                type: "submit",
                                                form: "filter-form",
                                                isLoading: isSubmitting || isLoading,
                                                colorScheme: "teal",
                                                children: "Apply filter"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        }))
    });
};
/* harmony default export */ var components_RoomFilter = ((0,mobxreact_esm/* observer */.Pi)(RoomFilter));

// EXTERNAL MODULE: ./node_modules/@chakra-ui/close-button/dist/chakra-ui-close-button.esm.js
var chakra_ui_close_button_esm = __webpack_require__(84746);
;// CONCATENATED MODULE: ./components/pages/ListingPage/components/WelcomeBar/welcomeBar.styles.ts


var StaticBarWrapper = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* HStack */.Ug, {
    baseStyle: function() {
        return {
            width: {
                base: "stretch",
                lg: "50vw"
            },
            justifyContent: "center",
            backgroundColor: "teal.100",
            padding: {
                base: "16px",
                md: "22px",
                lg: "18px"
            },
            position: "sticky",
            transform: {
                base: "translateY(-1px)",
                lg: "unset"
            },
            zIndex: theme/* EZIndexLayer.WELCOME_BAR */.qd.WELCOME_BAR,
            top: {
                base: "129px",
                md: "137px",
                lg: "136px"
            },
            boxShadow: "base",
            alignSelf: "flex-start"
        };
    }
});
var CloseButton = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_close_button_esm/* CloseButton */.P, {
    baseStyle: function() {
        return {
            alignSelf: "flex-end",
            backgroundColor: "blackAlpha.100",
            _hover: {
                backgroundColor: "blackAlpha.200"
            },
            _active: {
                backgroundColor: "blackAlpha.300"
            },
            _focus: {
                backgroundColor: "blackAlpha.300",
                boxShadow: "none"
            },
            position: "absolute",
            right: {
                base: 4,
                md: 8,
                lg: 4
            },
            top: 4
        };
    }
});
var WelcomeMessage = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Text */.xv, {
    baseStyle: function() {
        return {
            fontSize: {
                base: "xs",
                md: "sm"
            },
            fontWeight: {
                base: 500,
                lg: 600
            },
            lineHeight: {
                base: 4,
                md: 5
            },
            color: "#242E2E",
            paddingRight: 1
        };
    }
});

;// CONCATENATED MODULE: ./components/pages/ListingPage/components/WelcomeBar/index.tsx







var WelcomeBar = function() {
    var turnOffWelcomeMessage = function turnOffWelcomeMessage() {
        setIsWelcomeMessageOpen(false);
    };
    var ref = (0,react.useState)(true), isWelcomeMessageOpen = ref[0], setIsWelcomeMessageOpen = ref[1];
    var ref1 = (0,react.useState)("sm"), closeButtonSize = ref1[0], setCloseButtonSize = ref1[1];
    var isDesktop = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.LG */.yE.LG);
    var isMobile = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.BASE */.yE.BASE, theme/* EBreakPoint.MD */.yE.MD);
    (0,react.useEffect)(function() {
        setCloseButtonSize(isDesktop ? "sm" : "md");
    }, [
        isDesktop
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StaticBarWrapper, {
        hidden: !isWelcomeMessageOpen,
        order: {
            base: 0,
            lg: -1
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                spacing: 0,
                textAlign: "center",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WelcomeMessage, {
                        children: [
                            "Welcome to HomeRoom! ",
                            isMobile ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {}),
                            " Roommate-living you\u2019ll actually"
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        alignSelf: "flex-end",
                        height: 5,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                            iconName: "heart_solid.svg",
                            size: isMobile ? 16 : 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseButton, {
                size: closeButtonSize,
                onClick: turnOffWelcomeMessage
            })
        ]
    });
};
/* harmony default export */ var components_WelcomeBar = (WelcomeBar);

;// CONCATENATED MODULE: ./components/pages/ListingPage/listingPage.styles.ts



var listingPage_styles_Container = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Box */.xu);
var ListingPageContainer = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
    baseStyle: function() {
        return {
            width: {
                base: "stretch",
                lg: "50vw"
            },
            gridTemplateColumns: {
                base: "repeat(1, minmax(0, 1fr))",
                md: "repeat(2, minmax(0, 1fr))"
            },
            gridGap: {
                base: 4,
                md: 8
            },
            alignSelf: "flex-start",
            justifyContent: "center",
            background: "#fff",
            left: 0,
            top: 0,
            paddingTop: {
                base: 4,
                md: 6
            },
            paddingX: {
                base: 4,
                md: 8
            },
            zIndex: theme/* EZIndexLayer.CONTENT_VIEW */.qd.CONTENT_VIEW
        };
    }
});
var ListingPageWrapper = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Flex */.kC, {
    baseStyle: function() {
        return {
            paddingBottom: 0,
            position: "relative"
        };
    }
});
var LoadMoreButton = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_button_esm/* Button */.zx, {
    baseStyle: function() {
        return {
            border: "solid 1px",
            borderColor: "background.grey.200",
            background: "transparent",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "2rem",
            height: {
                base: "48px",
                lg: "40px"
            }
        };
    }
});
var listingPage_styles_Text = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Text */.xv, {
    baseStyle: function() {
        return {
            fontSize: "lg",
            fontWeight: 600,
            color: "text.grey.700",
            marginRight: "12px"
        };
    }
});
var ListingRoomWrapper = (0,chakraShouldForwardProp/* default */.Z)(chakra_ui_layout_esm/* Flex */.kC, function(props) {
    return {
        flexDirection: "column",
        alignItems: "center",
        alignSelf: "flex-start",
        width: {
            base: "full",
            lg: (props === null || props === void 0 ? void 0 : props.isEmpty) ? "full" : "stretch"
        },
        marginBottom: {
            base: 10,
            lg: 20
        }
    };
});
var MapBoxWrapper = (0,chakraShouldForwardProp/* default */.Z)(chakra_ui_layout_esm/* Box */.xu, function(props) {
    return {
        display: (props === null || props === void 0 ? void 0 : props.size) > 0 ? {
            base: !(props === null || props === void 0 ? void 0 : props.showMap) ? "none" : "block",
            lg: "block"
        } : "none",
        position: {
            base: "fixed",
            lg: "sticky"
        },
        width: {
            base: "full",
            lg: "stretch"
        },
        height: "stretch",
        top: {
            base: "64px",
            lg: "136px"
        },
        left: 0,
        zIndex: {
            base: theme/* EZIndexLayer.MODAL */.qd.MODAL,
            lg: theme/* EZIndexLayer.CONTENT_VIEW */.qd.CONTENT_VIEW
        },
        "& > div": {
            width: {
                base: "stretch",
                lg: "stretch"
            }
        }
    };
});
var RoomButtonShowMap = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_button_esm/* Button */.zx, {
    baseStyle: function() {
        return {
            position: "fixed",
            background: "background.button",
            display: {
                base: "flex",
                lg: "none"
            },
            boxShadow: "base",
            borderRadius: "20px",
            bottom: "22px",
            right: "20px",
            _hover: {
                background: "background.buttonHover"
            }
        };
    }
});
var RoomButtonShowMapText = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Text */.xv, {
    baseStyle: function() {
        return {
            fontWeight: 600,
            fontSize: "lg",
            color: "#fff",
            marginLeft: "10px"
        };
    }
});

// EXTERNAL MODULE: ./components/pages/ListingPage/utils.ts
var ListingPage_utils = __webpack_require__(25624);
;// CONCATENATED MODULE: ./components/pages/ListingPage/index.tsx

































var Mapbox = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9269), __webpack_require__.e(8251), __webpack_require__.e(3700), __webpack_require__.e(6647)]).then(__webpack_require__.bind(__webpack_require__, 26647));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26647)
            ];
        }
    },
    ssr: false
});
var MapContainer = dynamic_default()((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
    var response;
    return runtime_default().wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return Promise.all(/* import() */[__webpack_require__.e(9269), __webpack_require__.e(8419)]).then(__webpack_require__.bind(__webpack_require__, 48419));
            case 2:
                response = _ctx.sent;
                return _ctx.abrupt("return", response.MapContainer);
            case 4:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
})), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48419)
            ];
        }
    },
    ssr: false
});
var ListingPage = function(props) {
    var changePosition = function changePosition(lat, lng, zoomLevel) {
        try {
            if ((0,common/* checkValidCoordinates */.fG)(lat, lng)) {
                setCenter([
                    lat,
                    lng
                ]);
                if (zoomLevel) {
                    mapModule === null || mapModule === void 0 ? void 0 : mapModule.setView([
                        lat,
                        lng
                    ], zoomLevel);
                } else {
                    mapModule === null || mapModule === void 0 ? void 0 : mapModule.setView([
                        lat,
                        lng
                    ]);
                }
                mapModule === null || mapModule === void 0 ? void 0 : mapModule.invalidateSize();
            }
        } catch (error) {
            (0,API_error/* handleError */.S)(error, "components/pages/ListingPage/index.tsx", "changePosition");
        }
    };
    var openMap = function openMap() {
        setCenter(center);
        setShowMap(true);
        window && window.scrollTo(0, 0);
    };
    var loadMore = function loadMore() {
        var newLimit = countHouseList > limit + 10 ? limit + 10 : countHouseList;
        setLimit(newLimit);
    };
    var setQueryParams = function setQueryParams(data) {
        spinnerStore.showLoading();
        setIsLoading(true);
        var queryParams = (0,ListingPage_utils/* getQueryParams */.vl)(data, query);
        router.push({
            pathname: pathname,
            query: pickBy_default()(queryParams, (identity_default()))
        });
    };
    var openFilterModal = function openFilterModal() {
        setOpenModalFilter(true);
    };
    var isMobile = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.BASE */.yE.BASE, theme/* EBreakPoint.MD */.yE.MD);
    var isDesktop = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.LG */.yE.LG);
    var houseList = props.houseList, _countHouseList = props.countHouseList, countHouseList = _countHouseList === void 0 ? 0 : _countHouseList, defaultHouse = props.defaultHouse, metroList = props.metroList;
    var ref = (0,react.useState)(), mapModule = ref[0], setMapModule = ref[1];
    var ref1 = (0,react.useState)(false), showMap = ref1[0], setShowMap = ref1[1];
    var ref2 = (0,react.useState)([
        0,
        0
    ]), center = ref2[0], setCenter = ref2[1];
    var ref3 = (0,react.useState)(false), openModalFilter = ref3[0], setOpenModalFilter = ref3[1];
    var router = (0,next_router.useRouter)();
    var spinnerStore = (0,useStores/* useStores */.m)().spinnerStore;
    var ref4 = (0,react.useState)(false), isLoading = ref4[0], setIsLoading = ref4[1];
    var query = router.query, pathname = router.pathname;
    var currentMetro = query.metro, placeType = query.placeType;
    var isEntireHouse = placeType === roomDefaultValue/* EPlaceTypeEnum.ENTIRE_HOUSE */.C.ENTIRE_HOUSE;
    var ref5 = (0,react.useState)(isDesktop ? 9 : isMobile ? 7 : 11), limit = ref5[0], setLimit = ref5[1];
    var houseListWithPaging = houseList.slice(0, limit);
    var validHouseListWithPaging = (0,common/* getValidArray */._b)(houseListWithPaging);
    var ref6;
    var desktopImage = (ref6 = defaultHouse === null || defaultHouse === void 0 ? void 0 : defaultHouse.desktopHouseDefaultImage) !== null && ref6 !== void 0 ? ref6 : constants_images/* DESKTOP_HOUSE_DEFAULT_IMAGE */.yN;
    var ref7;
    var mobileImage = (ref7 = defaultHouse === null || defaultHouse === void 0 ? void 0 : defaultHouse.mobileHouseDefaultImage) !== null && ref7 !== void 0 ? ref7 : constants_images/* MOBILE_HOUSE_DEFAULT_IMAGE */.C8;
    (0,react.useEffect)(function() {
        setLimit(isDesktop ? 9 : isMobile ? 7 : 11);
    }, [
        isDesktop,
        isMobile
    ]);
    (0,react.useEffect)(function() {
        //INFO: disable loading state after push new route
        spinnerStore.hideLoading();
        setIsLoading(false);
    }, [
        query
    ]);
    (0,react.useEffect)(function() {
        if (Array.isArray(houseList) && mapModule) {
            var coordinates = (0,ListingPage_utils/* getCoordinatesFromHouses */.TA)(houseList);
            var ref = (0,_sliced_to_array/* default */.Z)(currentMetro ? (0,common/* getCenterOfCoordinates */.hN)(coordinates) : coordinates[0] || [
                0,
                0
            ], 2), centerLat = ref[0], centerLng = ref[1];
            var metroOption = metroList.find(function(metro) {
                return metro.name === currentMetro;
            }) || {};
            var ref1;
            var defaultZoom = currentMetro ? (ref1 = metroOption === null || metroOption === void 0 ? void 0 : metroOption.zoomLevel) !== null && ref1 !== void 0 ? ref1 : 10 : 10;
            changePosition(centerLat, centerLng, defaultZoom);
        }
    }, [
        houseList,
        mapModule
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(listingPage_styles_Container, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UTMCapture/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_RoomFilter, {
                openModalFilter: openModalFilter,
                setOpenModalFilter: setOpenModalFilter,
                setQueryParams: setQueryParams,
                metroList: metroList
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ListingPageWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ListingRoomWrapper, {
                        isEmpty: countHouseList <= 0,
                        children: [
                            !isEntireHouse && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_WelcomeBar, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_FilterResultBar, {
                                countHouseList: countHouseList,
                                onClick: openFilterModal
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ListingPageContainer, {
                                children: [
                                    isLoading ? Array.from(Array(4)).map(function(card, index) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_RoomCardSkeleton, {}, index);
                                    }) : validHouseListWithPaging.map(function(house, index) {
                                        var ref;
                                        var cardImages = (0,utils/* getListingMedia */.UI)((ref = house === null || house === void 0 ? void 0 : house.media) !== null && ref !== void 0 ? ref : []);
                                        var ref1;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomCard/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                    changePosition: changePosition,
                                                    images: cardImages,
                                                    availableDate: (ref1 = house === null || house === void 0 ? void 0 : house.availableDate) !== null && ref1 !== void 0 ? ref1 : new Date()
                                                }, omit_default()(house, "images")), {
                                                    defaultImageUrl: isMobile ? mobileImage : desktopImage,
                                                    tags: (0,common/* getValidArray */._b)(house === null || house === void 0 ? void 0 : house.tags)
                                                })),
                                                validHouseListWithPaging.length >= 4 ? index === 3 && !isEntireHouse && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LowerMidScroll_TrustCredibilityBlock, {}) : index === 2 && !isEntireHouse && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LowerMidScroll_TrustCredibilityBlock, {}),
                                                validHouseListWithPaging.length >= 7 ? index === 6 && !isEntireHouse && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LowerMidScroll_SavedMoneyBlock, {}) : index === Math.min(6, isMobile && validHouseListWithPaging.length >= 6 ? 6 : Math.floor(validHouseListWithPaging.length / 2)) && !isEntireHouse && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LowerMidScroll_SavedMoneyBlock, {})
                                            ]
                                        }, "card-".concat(house.id));
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RoomButtonShowMap, {
                                        onClick: openMap,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                iconName: "map_point.svg",
                                                size: 16
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomButtonShowMapText, {
                                                children: "Map"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            limit < countHouseList && countHouseList > validHouseListWithPaging.length && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LoadMoreButton, {
                                onClick: loadMore,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(listingPage_styles_Text, {
                                        marginRight: 2,
                                        lineHeight: 7,
                                        children: "More Houses"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* BiChevronDown */.OrA, {
                                        color: "#000",
                                        size: 18
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MapBoxWrapper, {
                        size: validHouseListWithPaging.length,
                        showMap: showMap,
                        children: validHouseListWithPaging.length > 0 && (showMap || isDesktop) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MapContainer, {
                            center: center,
                            zoom: 10,
                            minZoom: 3,
                            scrollWheelZoom: true,
                            tap: false,
                            doubleClickZoom: true,
                            zoomAnimation: true,
                            markerZoomAnimation: true,
                            fadeAnimation: true,
                            bounceAtZoomLimits: true,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mapbox, {
                                houseList: houseList,
                                setMapModule: setMapModule,
                                changePosition: changePosition,
                                setShowMap: setShowMap,
                                showMap: showMap
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_ListingPage = (ListingPage);

;// CONCATENATED MODULE: ./pages/index.tsx










var ListPage = function(props) {
    var ref, ref1;
    var houseList = props.houseList, countHouseList = props.countHouseList, isEntireHouse = props.isEntireHouse, metroList = props.metroList;
    var entireHouseFeatureFlagName = "".concat("production", "-").concat(featureFlags/* default.WEBSITE_LISTING_PAGE_ENTIRE_HOUSE */.Z.WEBSITE_LISTING_PAGE_ENTIRE_HOUSE);
    var entireHouseFeatureFlag = (0,lib.useFlag)(entireHouseFeatureFlagName);
    var isEnableEntireHouseFeature = entireHouseFeatureFlag && entireHouseFeatureFlag.enabled;
    var ref2;
    var validHouseList = !isEnableEntireHouseFeature ? (ref2 = (ref = (0,common/* getValidArray */._b)(houseList)) === null || ref === void 0 ? void 0 : ref.filter(function(house) {
        return house.placeType !== roomDefaultValue/* EPlaceTypeEnum.ENTIRE_HOUSE */.C.ENTIRE_HOUSE;
    })) !== null && ref2 !== void 0 ? ref2 : houseList : houseList;
    var ref3;
    var countValidHouseList = (ref3 = (ref1 = (0,common/* getValidArray */._b)(validHouseList)) === null || ref1 === void 0 ? void 0 : ref1.length) !== null && ref3 !== void 0 ? ref3 : countHouseList;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MainLayout/* default */.Z, {
        title: "HomeRoom | Listing",
        isEntireHouse: isEntireHouse,
        metroList: metroList,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pages_ListingPage, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            houseList: validHouseList,
            countHouseList: countValidHouseList
        }))
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (ListPage);


/***/ }),

/***/ 57156:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"multiCarousel_container___ff__"};

/***/ }),

/***/ 63559:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"roomCard_sliderContainer__6nDec"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6556,2453,260,3874,8499,5106,2088,3789,7536,2547,8018,4530,352,6896,7333,2069,9898,4386,1268,9574,808,3983,4784,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);